// extracted by mini-css-extract-plugin
export default {"testsContainer":"dXvCqa","capitalize":"R5haY5"};